/* 2026-09-25 Contact Saber feature (Joel picked mockup D2). Section: sections/aoam-contact-saber-feature.liquid.
   Parts glide together, then the lit render fades in ON TOP of them and the parts drop out unseen once it is
   opaque (a two-way crossfade dipped to half brightness). Taking it apart runs the same in reverse.
   Loops on its own once it scrolls into view; a press on the button takes over. Reduced motion: no loop.
   Delete this file with the section to roll back. */
(function () {
  // [part, width, exploded left, assembled left, z] in 1460-unit stage space, all cut from one to-scale image.
  var P = [[2,25,102,266,1],[1,56,19,263,3],[3,573,148,276,2],[4,51,749,809,3],[5,133,831,850,4],[6,88,994,973,5],[7,89,1111,1051,6],[9,51,1309,1133,6],[8,56,1226,1130,7],[10,55,1385,1141,8]];
  var W = 1460, T = { move: 1500, fade: 900, hold: 9000, rest: 2200 };
  // D3: one colour clock for every colour layer on the page, pinned to the same start time so they never drift apart.
  var HUE = ['#ff4a4a', '#ffa23a', '#f4f24a', '#4dff6a', '#3fe9ff', '#4a6bff', '#d04aff', '#ff4a4a'].map(function (c) { return { background: c }; });
  function init(sec) {
    if (sec.__csf) return; sec.__csf = true;
    var st = sec.querySelector('[data-csf-stage]'), tg = sec.querySelector('[data-csf-tg]');
    if (!st || !tg) return;
    var urls = (st.getAttribute('data-parts') || '').split('|');
    // The section now renders the parts in its HTML (fast first paint). Use those when they are all there; build them only as a fallback.
    var pre = st.querySelectorAll('.csf__pt');
    var els = pre.length === P.length ? Array.prototype.slice.call(pre) : P.map(function (q) {
      var d = document.createElement('div');
      d.className = 'csf__pt p' + q[0]; d.style.width = (q[1] / W * 100) + '%'; d.style.left = (q[2] / W * 100) + '%'; d.style.zIndex = q[4];
      var im = document.createElement('img'); im.src = urls[q[0] - 1]; im.alt = ''; im.decoding = 'async';
      d.appendChild(im);
      if (q[0] <= 4) { d.classList.add('off'); if (q[0] == 3) { var tb = document.createElement('i'); tb.className = 'csf__tube'; d.appendChild(tb); } }
      st.appendChild(d); return d;
    });
    var state = 'apart', goal = 'apart', busy = false, auto = true, pend = false, timers = [];
    var segs = tg.querySelectorAll('[data-v]');
    // The switch shows where the saber is heading (Parts / Assembled + lit), lime on the current one.
    function mark(g) { goal = g; for (var i = 0; i < segs.length; i++) { var on = (segs[i].getAttribute('data-v') === 'lit') === (g === 'together'); segs[i].classList.toggle('is-on', on); segs[i].setAttribute('aria-pressed', on ? 'true' : 'false'); } }
    function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
    // A press during a running move is remembered and played once the move lands, so the button never feels dead.
    function done() { busy = false; if (pend) { pend = false; state == 'apart' ? together() : apart(); } }
    function together() {
      if (busy) return; busy = true; sec.classList.add('is-moving'); mark('together');
      P.forEach(function (q, i) { var e = els[i]; e.style.transform = 'translateX(' + ((q[3] - q[2]) / q[1] * 100) + '%)';
        if (q[0] == 2 || q[0] == 9) { e.style.transitionDelay = '0s, .7s'; e.style.opacity = 0; } });
      later(function () { sec.classList.add('is-on'); }, T.move);
      later(function () { els.forEach(function (e) { e.style.transition = 'none'; e.style.transitionDelay = '0s'; e.style.opacity = 0; });
        sec.classList.remove('is-moving'); state = 'together'; done(); }, T.move + T.fade + 50);
    }
    function apart() {
      if (busy) return; busy = true; mark('apart');
      els.forEach(function (e) { e.style.transition = 'none'; e.style.transitionDelay = '0s'; e.style.opacity = 1; });
      void st.offsetWidth; els.forEach(function (e) { e.style.transition = ''; });
      sec.classList.remove('is-on'); sec.classList.add('is-moving');
      later(function () { els.forEach(function (e) { e.style.transform = 'translateX(0)'; }); }, T.fade);
      later(function () { sec.classList.remove('is-moving'); state = 'apart'; done(); }, T.fade + T.move);
    }
    tg.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-v]') : null; if (!b) return;
      auto = false; var want = b.getAttribute('data-v') === 'lit' ? 'together' : 'apart';
      if (busy) { pend = want !== goal; return; }
      if (want !== state) { want === 'together' ? together() : apart(); }
    });
    function loop() { if (!auto) return; together(); later(function () { if (auto) apart(); }, T.move + T.fade + T.hold); later(loop, (T.move + T.fade) * 2 + T.hold + T.rest); }
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce && sec.animate) sec.querySelectorAll('.csf__col').forEach(function (c) { try { var a = c.animate(HUE, { duration: 21000, iterations: Infinity }); a.startTime = 0; } catch (e) {} });
    if (reduce) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); later(loop, 600); } }, { threshold: 0.35 });
      io.observe(st);
    } else later(loop, 1800);
  }
  function boot() { var s = document.querySelectorAll('[data-csf]'); for (var i = 0; i < s.length; i++) init(s[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
